/* WOKORA UI state v1 — persistent in-tab navigation/back restoration */
(() => {
  'use strict';
  if (window.WokoraUIState) return;

  const PREFIX = 'wokora_ui_state_v1:';
  const TTL = 2 * 60 * 60 * 1000;
  const TRANSIENT_PARAMS = ['preview_theme_id', 'variant', '_pos', '_sid', '_ss'];

  function pageKey() {
    try {
      const url = new URL(window.location.href);
      TRANSIENT_PARAMS.forEach((name) => url.searchParams.delete(name));
      const query = url.searchParams.toString();
      return `${url.pathname}${query ? `?${query}` : ''}`;
    } catch (_) {
      return window.location.pathname || '/';
    }
  }

  function storageKey(scope) {
    return `${PREFIX}${scope || 'page'}:${pageKey()}`;
  }

  function read(scope) {
    try {
      const key = storageKey(scope);
      const raw = sessionStorage.getItem(key);
      if (!raw) return {};
      const data = JSON.parse(raw);
      if (!data || typeof data !== 'object') return {};
      if (data.updatedAt && Date.now() - data.updatedAt > TTL) {
        sessionStorage.removeItem(key);
        return {};
      }
      return data;
    } catch (_) {
      return {};
    }
  }

  function write(scope, patch) {
    try {
      const next = Object.assign({}, read(scope), patch || {}, { updatedAt: Date.now() });
      sessionStorage.setItem(storageKey(scope), JSON.stringify(next));
      return next;
    } catch (_) {
      return {};
    }
  }

  function remove(scope) {
    try { sessionStorage.removeItem(storageKey(scope)); } catch (_) {}
  }

  function replaceUrl(url) {
    try { history.replaceState(history.state || {}, '', url); } catch (_) {}
  }

  function currentUrlWithoutHash() {
    return `${window.location.pathname}${window.location.search}`;
  }

  window.WokoraUIState = {
    read,
    write,
    remove,
    replaceUrl,
    pageKey,
    currentUrlWithoutHash
  };

  window.addEventListener('pageshow', (event) => {
    document.dispatchEvent(new CustomEvent('wokora:restore-ui-state', {
      detail: { persisted: Boolean(event.persisted) }
    }));
  });
})();
